import { render, staticRenderFns } from "./SearchBox.vue?vue&type=template&id=540d39e0"
import script from "./SearchBox.ts?vue&type=script&lang=ts&external"
export * from "./SearchBox.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports